import { Schema } from "rsuite";

import i18n from "utils/i18n";

import { OcrMethods } from "store/environments/tenants/tenant-configurations/tenant-configurations-types";

export const ocrMethods = [
    {
        label: i18n.t(
            "tenantConfig.featureConfigurations.ocrConfigurations.labels.photonSync"
        ),
        value: OcrMethods.PhotonSync,
    },
    {
        label: i18n.t(
            "tenantConfig.featureConfigurations.ocrConfigurations.labels.photonHitl"
        ),
        value: OcrMethods.PhotonHitl,
    },
    {
        label: i18n.t(
            "tenantConfig.featureConfigurations.ocrConfigurations.labels.llm"
        ),
        value: OcrMethods.Llm,
    },
    {
        label: i18n.t(
            "tenantConfig.featureConfigurations.ocrConfigurations.labels.passthroughOnly"
        ),
        value: OcrMethods.PassthroughOnly,
    },
];

const validateSlash = (value: string) => {
    return !value.includes("/");
};

const validateWhitespace = (value: string) => {
    return value === value.trim();
};

export const { StringType } = Schema.Types;

export const formModel = Schema.Model({
    name: StringType()
        .isRequired(i18n.t("generalValidationMessages.isRequired"))
        .addRule(
            validateWhitespace,
            i18n.t("generalValidationMessages.whitespaceNotAllowed")
        )
        .addRule(
            validateSlash,
            i18n.t("generalValidationMessages.slashCharacter")
        ),
    address: StringType()
        .isRequired(i18n.t("generalValidationMessages.isRequired"))
        .isEmail(i18n.t("generalValidationMessages.isEmail"))
        .addRule(
            validateSlash,
            i18n.t("generalValidationMessages.slashCharacter")
        ),
});
